import { Palette } from '@/themes/themeOverrides/Palette';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';

export const MuiFormLabelStyles = {
    styleOverrides: {
        root: {
            color: Palette.gray.gray600,
            fontSize: '14px',
            lineHeight: '18px',
            padding: '4px 6px',
            '&.Mui-focused': {
                color: Palette.black,
            },
            '&.Mui-focused + .MuiInputBase-root.MuiOutlinedInput-root': {
                outline: `2px solid ${Palette.yellow.yellow400}`,
            },
            '&.MuiInputLabel-shrink.Mui-error, &.MuiFormLabel-filled.Mui-error, &.MuiFormLabel-focused.Mui-error': {
                color: Palette.red.red400,
            },
            '&.MuiInputLabel-shrink, &.MuiFormLabel-filled, &.MuiFormLabel-focused': {
                fontSize: '11px',
                top: '2px',
                left: '-3px',
                padding: '0 4px',
                lineHeight: '16px',
                color: Palette.gray.gray600,
                backgroundColor: Palette.white,
                '&.Mui-disabled': {
                    color: Palette.gray.gray900,
                },
            },
            '&.MuiInputLabel-root': {
                transform: 'translate(14px, 9px) scale(1)',
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    fontSize: '16px',
                },
                '&.MuiInputLabel-shrink': {
                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                        fontSize: '11px',
                    },
                },
            },
            '&.MuiInputLabel-root.Mui-focused': {
                transform: 'translate(14px, -11px) scale(1)',
            },
            '&.MuiInputLabel-root.MuiFormLabel-filled': {
                transform: 'translate(14px, -11px) scale(1)',
            },
            '&.MuiAutocomplete-root.input-filled .MuiInputLabel-root': {
                transform: 'translate(14px, -11px) scale(1) !important',
            },
            '&.MuiAutocomplete-root.input-filled .MuiFormLabel-root': {
                transform: 'translate(14px, -11px) scale(1) !important',
            },
        },
    },
};
